export const SKILL_LEVEL = {
  1: 'Beginner',
  2: 'Novice',
  3: 'Intermediate',
  4: 'Advanced',
  5: 'Expert',
};

export const SKILL_TYPES = {
  EARNED: 'earned',
  DESIRED: 'desired',
  SELF_REPORTED: 'selfReported',
} as const;
